/*! React Starter Kit | MIT License | http://www.reactstarterkit.com/ */

import React from 'react'; // eslint-disable-line no-unused-vars
import PropTypes from 'prop-types';
import styles from './HomePage.scss';
import baseComponent from '../../decorators/baseComponent';
import { connect } from 'react-redux';
import Context from '../../Context';
import BaseReactComponent from '../Util/BaseReactComponent';
import {
  loadInstallers,
  addInstaller,
  updateInstaller,
  disableInstaller,
  loadInstallerCompany,
  onEditInstallerCompany
} from '../../actioncreators/InstallerCompanyActions';
import {
  loadInstallerCompanies,
  addInstallerCompany,
  updateInstallerCompany,
  loadCommercialOffers,
  loadFilterShops,
  saveCommercialOffer,
  saveFilterShop,
  disableInstallerCompany,
  loadProducts,
  addProduct,
  updateProduct,
  disableProduct,
  loadSoftwareVersions,
  addSoftwareVersion,
  updateSoftwareVersion,
  deleteSoftwareVersion,
  loadManager,
  loadDocuments,
  addDocument,
  removeDocument,
  changeTab
} from '../../actioncreators/ZehnderActions.js';
import Header from '../Header';
import InstallerCompanyTable from './InstallerCompanyTable';
import InstallerTable from './InstallerTable';
import Tabs from 'react-bootstrap/lib/Tabs';
import Tab from 'react-bootstrap/lib/Tab';
import InstallerCompanyEditor from '../InstallerCompanyEditor';
import InstallerEditor from '../InstallerEditor';
import CommercialOffers from '../CommercialOffers';
import FilterShops from '../FilterShops';
import ProductEditor from '../Product/ProductEditor';
import ProductsTable from '../Product/ProductsTable';
import SoftwareVersionTable from '../SoftwareVersion/SoftwareVersionTable';
import SoftwareVersionEditor from '../SoftwareVersion/SoftwareVersionEditor';
import DocumentsPanel from '../Document/DocumentsPanel';
import DocumentEditor from '../Document/DocumentEditor';
import { getConfig } from '../settings';

var titles = {
  ADMIN: 'Zehnder Cloud Management',
  ZEHNDER: 'Zehnder Cloud Management',
  INSTALLER_COMPANY: 'Installer Company Management',
  INSTALLER: 'Gateway Management'
};

@connect(state => ({
  user: state.login.user,
  installerCompany: state.installerCompany.installerCompany,
  installerCompanyToEdit: state.installerCompany.installerCompanyToEdit,
  manager: state.zehnder.manager,
  largestrole: state.login.largestrole,
  installers: state.installerCompany.installers,
  installerCompanies: state.zehnder.installerCompanies,
  commercialOffers: state.zehnder.commercialOffers,
  filterShops: state.zehnder.filterShops,
  products: state.zehnder.products,
  softwareVersions: state.zehnder.softwareVersions,
  tab: state.zehnder.tab,
  config: getConfig(state)
}))
@baseComponent(styles)
class HomePage extends BaseReactComponent {
  constructor() {
    super();
    this.state = {};
    this.state.editInstaller = undefined;
    this.state.editProduct = undefined;
    this.state.editDocument = undefined;
  }

  componentWillMount() {
    if (typeof window !== 'undefined' && window.location && !this.props.config) {
      console.log('Redirect to pickWebsite');
      window.location.replace('/pickWebsite');
    }
  }

  componentDidMount() {
    this.init(this.props);
  }

  componentWillReceiveProps(nextProps) {
    if (!this.props || (this.props && this.props.config && this.props.config.customer !== nextProps.config.customer)) {
      this.init(nextProps);
    }

    if (this.state.editSoftwareVersion !== undefined) {
      this.state.editSoftwareVersion = nextProps.softwareVersions.find(s => s.id === this.state.editSoftwareVersion.id);
    }

    if (
      nextProps.location.state !== null &&
      nextProps.location.state !== undefined &&
      nextProps.location.state.tab !== this.props.tab
    ) {
      this.setState({
        tab: nextProps.location.state.tab
      });
    }
  }

  init = props => {
    let roles = props.user.roles;

    if (roles.includes('ZEHNDER')) {
      loadManager(props.user.id)(props.dispatch);
      loadInstallerCompanies()(props.dispatch);
      loadCommercialOffers()(props.dispatch);
      loadFilterShops()(props.dispatch);
      loadProducts()(props.dispatch);
      loadSoftwareVersions()(props.dispatch);
      loadDocuments()(props.dispatch);
    } else if (roles.includes('INSTALLER_COMPANY')) {
      loadInstallers(props.user)(props.dispatch);
      loadInstallerCompany(props.user.id)(props.dispatch);
    }

    let title = titles[props.largestrole];
    Context.getInstance().onSetTitle(title);
    document.title = title;
  };

  handleTabsChange(value) {
    changeTab(this.props.dispatch, value);
  }

  handleInstallerCompanyChange() {
    loadInstallerCompanies()(this.props.dispatch);
    this.handleTabsChange(0);
  }

  handleProductChange() {
    loadProducts()(this.props.dispatch);
    this.handleTabsChange(4);
  }

  handleSoftwareVersionChange() {
    loadSoftwareVersions()(this.props.dispatch);
    this.handleTabsChange(7);
  }

  handleBinaryChange() {
    loadSoftwareVersions()(this.props.dispatch);
    this.handleTabsChange(8);
  }

  handleCommercialOfferChange() {
    loadCommercialOffers()(this.props.dispatch);
  }

  handleFilterShopChange() {
    loadFilterShops()(this.props.dispatch);
  }

  handleDocumentChange() {
    loadDocuments()(this.props.dispatch);
    this.handleTabsChange(9);
  }

  installerCompanyAdd(installerCompany) {
    let self = this;
    addInstallerCompany(installerCompany, function(err) {
      if (!err) {
        // self.setState({editInstallerCompany: installerCompany});
        self.handleInstallerCompanyChange();
      }
    })(this.props.dispatch);
  }

  productAdd(product) {
    let self = this;
    addProduct(product, function(err) {
      if (!err) {
        self.setState({ editProduct: product });
        self.handleProductChange();
      }
    })(this.props.dispatch);
  }

  documentAdd(document, callback) {
    let self = this;
    addDocument(document, function(err) {
      if (!err) {
        callback();

        self.setState({ editDocument: document });
        self.handleDocumentChange();
      }
    })(this.props.dispatch);
  }

  addDocument() {
    this.handleTabsChange(10);
  }

  softwareVersionAdd(swVersion, callback) {
    let self = this;
    addSoftwareVersion(swVersion, function(err) {
      if (!err) {
        callback();

        self.setState({ editSoftwareVersion: swVersion });
        self.handleSoftwareVersionChange();
      }
    })(this.props.dispatch);
  }

  installerCompanyUpdate(installerCompany) {
    let self = this;
    updateInstallerCompany(installerCompany, function(err) {
      if (!err) {
        self.handleInstallerCompanyChange();
      }
    })(this.props.dispatch);
  }

  productUpdate(product) {
    let self = this;
    updateProduct(product, function(err) {
      if (!err) {
        self.handleProductChange();
      }
    })(this.props.dispatch);
  }

  softwareVersionUpdate(swVersion) {
    let self = this;
    updateSoftwareVersion(swVersion, function(err) {
      if (!err) {
        self.handleSoftwareVersionChange();
      }
    })(this.props.dispatch);
  }

  installerUpdate(installer) {
    let self = this;
    updateInstaller(installer, function(err) {
      if (!err) {
        self.handleInstallerChange();
      }
    })(this.props.dispatch);
  }

  handleInstallerChange() {
    loadInstallers(this.props.user)(this.props.dispatch);
    this.handleTabsChange(0);
  }

  installerAdd(installer) {
    let self = this;
    addInstaller(installer, function(err) {
      if (!err) {
        self.setState({ editInstaller: installer });
        self.handleInstallerChange();
      }
    })(this.props.dispatch);
  }

  onEditInstaller(installer) {
    //Set installer edit page
    this.handleTabsChange(1);

    installer.editMode = 'EDIT';
    this.setState({ editInstaller: installer });
  }

  onEditInstallerCompanyRow(installerCompany) {
    this.handleTabsChange(1);

    // installerCompany.editMode = 'EDIT';
    onEditInstallerCompany(installerCompany)(this.props.dispatch);
  }

  onEditProduct(product) {
    this.handleTabsChange(5);

    product.editMode = 'EDIT';
    this.setState({ editProduct: product });
  }

  onEditSoftwareVersion(swVersion) {
    this.handleTabsChange(8);

    swVersion.editMode = 'EDIT';
    this.setState({ editSoftwareVersion: swVersion });
  }

  productToEdit() {
    return this.state.editProduct;
  }

  documentToEdit() {
    return this.state.editDocument;
  }

  softwareVersionToEdit() {
    return this.state.editSoftwareVersion;
  }

  installerToEdit() {
    return this.state.editInstaller;
  }

  installerCompanyAddNew() {
    //Set installer edit page
    this.handleTabsChange(1);

    onEditInstallerCompany({
      id: undefined,
      companyName: '',
      username: '',
      email: '',
      address: '',
      country: undefined,
      editMode: 'NEW'
    })(this.props.dispatch);
  }

  productAddNew() {
    //Set product edit page
    this.handleTabsChange(5);

    this.setState({
      editProduct: {
        productID: undefined,
        name: '',
        swVersions: [],
        editMode: 'NEW',
        articlePrefix: ''
      }
    });
  }

  documentAddNew() {
    //Set product edit page
    this.handleTabsChange(10);

    this.setState({
      editDocument: {
        id: undefined,
        type: '',
        url: '',
        name: '',
        description: '',
        situation: undefined,
        model: undefined,
        country: undefined,
        editMode: 'NEW'
      }
    });
  }

  removeDocument(document) {
    removeDocument(document, () => {
      this.handleTabsChange(9);
      loadDocuments()(this.props.dispatch);
    })(this.props.dispatch);
  }

  softwareVersionAddNew() {
    //if (swVersion === undefined) {
    //  this.setState({
    //    editSoftwareVersion: {
    //      version: undefined,
    //      releaseNotes: "",
    //      editMode: 'NEW'
    //    }
    //  });
    //}
    this.handleTabsChange(8);

    this.setState({
      editSoftwareVersion: {
        version: '',
        product: undefined,
        productI: undefined,
        editMode: 'NEW',
        name: '',
        md5: ''
      }
    });
  }

  deleteInstaller(installer) {
    let self = this;
    disableInstaller(installer, function(err) {
      if (!err) {
        self.handleInstallerChange();
        self.handleTabsChange(0);
      }
    })(self.props.dispatch);
  }

  deleteInstallerCompany(installerCompany) {
    let self = this;
    disableInstallerCompany(installerCompany, function(err) {
      if (!err) {
        loadInstallerCompanies()(self.props.dispatch);
        self.handleTabsChange(0);
      }
    })(self.props.dispatch);
  }

  deleteProduct(product) {
    let self = this;
    disableProduct(product, function(err) {
      if (!err) {
        loadProducts()(self.props.dispatch);
        self.handleTabsChange(4);
      }
    })(self.props.dispatch);
  }

  deleteSoftwareVersion(swVersion) {
    let self = this;
    deleteSoftwareVersion(swVersion, function(err) {
      if (!err) {
        loadSoftwareVersions()(self.props.dispatch);
        self.handleTabsChange(7);
      }
    })(self.props.dispatch);
  }

  installerAddNew() {
    //Set installer edit page
    this.handleTabsChange(1);

    this.setState({
      editInstaller: {
        id: undefined,
        username: '',
        email: '',
        phonenumber: '',
        editMode: 'NEW',
        beta: false
      }
    });
  }

  saveComOffer(offer) {
    let self = this;

    saveCommercialOffer(offer, function(err) {
      if (!err) {
        self.handleCommercialOfferChange();
      }
    })(this.props.dispatch);
  }

  saveShop(filterShop) {
    let self = this;

    saveFilterShop(filterShop, function(err) {
      if (!err) {
        self.handleFilterShopChange();
      }
    })(this.props.dispatch);
  }

  render() {
    let roles = this.props.user.roles;

    let rows;
    let table;
    let tabs;
    if (roles.includes('ZEHNDER')) {
      rows = this.props.installerCompanies;
      rows = rows.filter(row => row.accountEnabled);

      table = (
        <InstallerCompanyTable
          rows={rows}
          changeTab={this.handleTabsChange.bind(this)}
          onEditInstallerCompany={this.onEditInstallerCompanyRow.bind(this)}
          onAddNew={this.installerCompanyAddNew.bind(this)}
        />
      );

      const productsTable = (
        <ProductsTable
          rows={this.props.products}
          changeTab={this.handleTabsChange.bind(this)}
          onEditProduct={this.onEditProduct.bind(this)}
          onAddNew={this.productAddNew.bind(this)}
        />
      );

      const softwareVersionTable = (
        <SoftwareVersionTable
          rows={this.props.softwareVersions}
          changeTab={this.handleTabsChange.bind(this)}
          onEditSoftwareVersion={this.onEditSoftwareVersion.bind(this)}
          onAddNew={this.softwareVersionAddNew.bind(this)}
        />
      );

      const documentsPanel = (
        <DocumentsPanel addDocument={this.documentAddNew.bind(this)} removeDocument={this.removeDocument.bind(this)} />
      );

      const extraTabs =
        typeof this.props.config.homepage === 'undefined'
          ? undefined
          : [
              <Tab
                title={this.getMessage('tabs.commercial-offers-tab')}
                key={26}
                eventKey={26}
                className="HomePage-tabs-tab"
                tabClassName={this.props.config.homepage.zehnder.tabs.commercial_offers !== true ? 'hidden' : ''}>
                <CommercialOffers
                  commercialOffers={this.props.commercialOffers}
                  saveCommercialOffer={this.saveComOffer.bind(this)}
                />
              </Tab>,
              <Tab
                title={this.getMessage('tabs.filter-shops-tab')}
                key={3}
                eventKey={3}
                className="HomePage-tabs-tab"
                tabClassName={this.props.config.homepage.zehnder.tabs.filter_shops !== true ? 'hidden' : ''}>
                <FilterShops filterShops={this.props.filterShops} saveFilterShop={this.saveShop.bind(this)} />
              </Tab>,
              <Tab
                title={this.getMessage('tabs.documents-tab')}
                key={9}
                eventKey={9}
                className="HomePage-tabs-tab"
                tabClassName={this.props.config.homepage.zehnder.tabs.documents !== true ? 'hidden' : ''}>
                <div id="documents" className="col s12">
                  {documentsPanel}
                </div>
              </Tab>,
              <Tab
                title={this.getMessage('tabs.documents-tab')}
                key={1}
                eventKey={10}
                className="HomePage-tabs-tab"
                tabClassName="hidden">
                <DocumentEditor
                  changeTab={this.handleTabsChange.bind(this)}
                  addDocument={this.documentAdd.bind(this)}
                  document={this.documentToEdit.bind(this)}
                />
              </Tab>,
              <Tab
                title={this.getMessage('tabs.products-tab')}
                key={4}
                eventKey={4}
                className="HomePage-tabs-tab"
                tabClassName={this.props.config.homepage.zehnder.tabs.manage_products !== true ? 'hidden' : ''}>
                <div id="products" className="col s12">
                  {productsTable}
                </div>
              </Tab>,
              <Tab
                title={this.getMessage('tabs.add-product-tab')}
                key={5}
                eventKey={5}
                className="HomePage-tabs-tab"
                tabClassName="hidden">
                <ProductEditor
                  changeTab={this.handleTabsChange.bind(this)}
                  handleProductChange={this.handleProductChange.bind(this)}
                  addProduct={this.productAdd.bind(this)}
                  product={this.productToEdit.bind(this)}
                  updateProduct={this.productUpdate.bind(this)}
                  disableProduct={this.deleteProduct.bind(this)}
                />
              </Tab>,
              <Tab
                title={this.getMessage('tabs.softwareVersions-tab')}
                key={7}
                eventKey={7}
                className="HomePage-tabs-tab"
                tabClassName={this.props.config.homepage.zehnder.tabs.manage_firmware !== true ? 'hidden' : ''}>
                <div id="softwareVersions" className="col s12">
                  {softwareVersionTable}
                </div>
              </Tab>,
              <Tab
                title={this.getMessage('tabs.add-softwareVersion-tab')}
                key={8}
                eventKey={8}
                className="HomePage-tabs-tab"
                tabClassName="hidden">
                <SoftwareVersionEditor
                  changeTab={this.handleTabsChange.bind(this)}
                  handleSoftwareVersionChange={this.handleSoftwareVersionChange.bind(this)}
                  addSoftwareVersion={this.softwareVersionAdd.bind(this)}
                  softwareVersion={this.softwareVersionToEdit.bind(this)}
                  updateSoftwareVersion={this.softwareVersionUpdate.bind(this)}
                  deleteSoftwareVersion={this.deleteSoftwareVersion.bind(this)}
                />
              </Tab>
            ];

      const managerTabs = this.props.manager && !this.props.manager.country ? extraTabs : <div />;

      tabs =
        typeof this.props.config.homepage === 'undefined' ? (
          undefined
        ) : (
          <Tabs
            className="col s12 HomePage-tabs-tabs"
            activeKey={this.props.tab}
            onSelect={this.handleTabsChange.bind(this)}>
            <Tab
              title={this.getMessage('tabs.installer-companies-tab')}
              key={0}
              eventKey={0}
              className="HomePage-tabs-tab"
              tabClassName={this.props.config.homepage.zehnder.tabs.installer_companies !== true ? 'hidden' : ''}>
              <div id="installerCompanies" className="col s12">
                {table}
              </div>
            </Tab>
            <Tab
              title={this.getMessage('tabs.add-installer-company-tab')}
              key={1}
              eventKey={1}
              className="HomePage-tabs-tab"
              tabClassName="hidden">
              {this.props.tab !== 1 ? (
                <div />
              ) : (
                <InstallerCompanyEditor
                  changeTab={this.handleTabsChange.bind(this)}
                  handleInstallerCompanyChange={this.handleInstallerCompanyChange.bind(this)}
                  addInstallerCompany={this.installerCompanyAdd.bind(this)}
                  installerCompany={this.props.installerCompanyToEdit}
                  onEditInstallerCompany={i => onEditInstallerCompany(i)(this.props.dispatch)}
                  updateInstallerCompany={this.installerCompanyUpdate.bind(this)}
                  disableInstallerCompany={this.deleteInstallerCompany.bind(this)}
                />
              )}
            </Tab>
            {managerTabs}
          </Tabs>
        );
    } else if (roles.includes('INSTALLER_COMPANY')) {
      rows = this.props.installers;
      table = (
        <InstallerTable
          rows={rows}
          changeTab={this.handleTabsChange.bind(this)}
          onEditInstaller={this.onEditInstaller.bind(this)}
          onAddNew={this.installerAddNew.bind(this)}
        />
      );

      tabs = (
        <Tabs
          className="col s12 HomePage-tabs-tabs"
          key="installerCompanies"
          activeKey={this.props.tab}
          onSelect={this.handleTabsChange.bind(this)}>
          <Tab title={this.getMessage('tabs.installers-tab')} eventKey={0} className="HomePage-tabs-tab">
            <div id="installerCompanies" className="col s12">
              {table}
            </div>
          </Tab>
          <Tab title={this.getMessage('tabs.add-installer-tab')} key={1} eventKey={1} className="HomePage-tabs-tab">
            <InstallerEditor
              changeTab={this.handleTabsChange.bind(this)}
              handleInstallerChange={this.handleInstallerChange.bind(this)}
              addInstaller={this.installerAdd.bind(this)}
              installer={this.installerToEdit.bind(this)}
              updateInstaller={this.installerUpdate.bind(this)}
              disableInstaller={this.deleteInstaller.bind(this)}
            />
          </Tab>
        </Tabs>
      );
    } else if (roles.includes('INSTALLER')) {
      tabs = (
        <Tabs
          className="col s12 HomePage-tabs-tabs"
          activeKey={this.props.tab}
          onSelect={this.handleTabsChange.bind(this)}>
          <Tab title={this.getMessage('tabs.installer-tab')} eventKey={0} className="HomePage-tabs-tab">
            <div id="installerPage" className="container">
              <br />
              <br />
              {this.getIntlMessage('global.intentionally-left-blank')}
            </div>
          </Tab>
        </Tabs>
      );
    }

    return (
      <div>
        <Header
          {...this.props.user}
          pageName="homepage"
          title={typeof this.props.config === 'undefined' ? undefined : this.props.config.title}
        />

        <div className="HomePage">
          <div className="HomePage-tabs">{tabs}</div>
        </div>
      </div>
    );
  }
}

HomePage.defaultProps = {
  componentName: 'homepage'
};

export default HomePage;



// WEBPACK FOOTER //
// /src/components/HomePage/HomePage.js